import React, { useEffect } from 'react';

import { Select } from '~/eds/src/components/Select/Select';
import { SharedSelectProps } from '~/eds/src/types/SharedSelectProps';
import { EnumValue } from '~/evifields/src/types/Value';

import { RenderComponentProps } from './types';

type Props = RenderComponentProps<SharedSelectProps<EnumValue, boolean>>;

export const AsyncSelectComponent = ({ asyncProps, innerProps }: Props) => {
  const { asyncOptions, onMount, onQuery } = asyncProps;

  const {
    data: options = [],
    error,
    isFetching,
    selectAllCount,
  } = asyncOptions;

  useEffect(() => {
    innerProps?.onChangeSelectAll?.(selectAllCount);
  }, [selectAllCount]);

  return (
    <Select
      {...innerProps}
      error={error}
      isLoading={isFetching}
      options={options}
      onMount={onMount}
      onSearch={onQuery}
      selectAllCount={selectAllCount}
    />
  );
};
